/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */
// Composables
import { createVuetify } from 'vuetify'

import * as components from 'vuetify/components'
import * as labsComponents from 'vuetify/labs/components'
import * as directives from 'vuetify/directives'

export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#1867C0',
          secondary: '#5CBBF6',
        },
      },
    },
  },

  defaults: {
    VTextField: {
      color: 'blue-darken-3',
    },
    VAutocomplete: {
      color: 'blue-darken-3',
    },
    VSelect: {
      color: 'blue-darken-3',
    },
    VCombobox: {
      color: 'blue-darken-3',
    },
    VTextarea: {
      color: 'blue-darken-3',
    },
    VFileInput: {
      color: 'blue-darken-3',
    },
    VDateInput: {
      color: 'blue-darken-3',
    },
    VDatePicker: {
      color: 'blue-darken-3',
    },
    VTimePicker: {
      color: 'blue-darken-3',
    },
    VCheckbox: {
      color: 'blue-darken-3',
    },
    VCheckboxBtn: {
      color: 'blue-darken-3',
    },
    VRadio: {
      color: 'blue-darken-3',
    },
    VRadioGroup: {
      color: 'blue-darken-3',
    },
    VSwitch: {
      color: 'blue-darken-3',
    },
    VSlider: {
      color: 'blue-darken-3',
    },
    VRangeSlider: {
      color: 'blue-darken-3',
    },
    VColorPicker: {
      color: 'blue-darken-3',
    }
  },

  components: {
    ...components,
    ...labsComponents,
    ...directives
  },
})
